import { render } from "./apRadio.vue?vue&type=template&id=0ca358c8&scoped=true&ts=true"
import script from "./apRadio.vue?vue&type=script&lang=ts"
export * from "./apRadio.vue?vue&type=script&lang=ts"

import "./apRadio.vue?vue&type=style&index=0&id=0ca358c8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca358c8"]])

export default __exports__